<template>
  <panel light>
    <h5 slot="heading" class="panel-title">{{pageTitle}}</h5>
    <div slot="heading" class="heading-elements">
      <div class="heading-buttons">
        <router-link :to="{name: 'category/create', query: {search}}" class="btn btn-success">Ajouter un métier</router-link>
      </div>
    </div>

    <div slot="body" class="form-inline">
      <form-group>
        <form-input-search :value="filter.search" debounce @input="setFilterSearch"></form-input-search>
      </form-group>
      <form-group>
        <button v-if="isFiltered" type="button" class="btn btn-default" @click="resetFilter()">Effacer les filtres</button>
      </form-group>
    </div>

    <div slot="content" class="table-responsive">
      <table class="table table-striped table-lg">
        <thead>
        <tr>
          <th width="135">Aperçu</th>
          <th>Nom du métier</th>
          <th width="100" class="text-center">Statut</th>
          <th width="80" class="text-center">Actions</th>
        </tr>
        </thead>
        <tbody v-if="categories.length">
        <tr v-for="category in categories" :key="category.id">
          <td class="centered">
            <media-image :media="category.icon" empty-label="Pas d'image" thumbnail />
          </td>
          <td>
            <h6 class="no-margin text-semibold">
              <router-link :to="{name: 'category/edit', params: {id: category.id}}">{{category.name}}</router-link>
            </h6>
          </td>
          <td class="text-center">
            <publishing-status class="cursor-pointer" :value="category.published" @hide="setCategoryPublished(category, false)" @show="setCategoryPublished(category)"></publishing-status>
          </td>
          <td class="text-center">
            <ul is="table-row-actions">
              <li>
                <router-link :to="{name: 'category/edit', params: {id: category.id}}"><i class="icon-pencil7"></i> Modifier</router-link>
              </li>
              <li class="divider"></li>
              <li><a @click="deleteCategory(category)"><i class="icon-bin"></i> Supprimer</a></li>
            </ul>
          </td>
        </tr>
        </tbody>
        <tbody v-else-if="$apollo.loading">
        <tr>
          <td colspan="4" class="text-center">
            <h4>Chargement&hellip;</h4>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="4" class="text-center">
            <h4>Aucun résultat</h4>
            <router-link :to="{name: 'category/create', query: {search}}" class="btn btn-success">Ajouter un métier</router-link>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <pagination slot="footer" :total="results.totalCount" v-model="pagination"></pagination>
  </panel>
</template>

<script>
import { mapActions } from 'vuex';

import _map from "lodash/map";
import _some from 'lodash/some';
// import _mapValues from 'lodash/mapValues';
// import _keyBy from 'lodash/keyBy';
// import _pick from 'lodash/pick';
import FormInputSearch from "package-common-vuejs/src/components/form/FormInputSearch";
import Pagination from "package-common-vuejs/src/components/Pagination";
import TableRowActions from "package-common-vuejs/src/components/table/TableRowActions";
import MediaImage from '../../components/MediaImage';
import PublishingStatus from "../../components/PublishingStatus";

import CategoryListQuery from "./graphql/CategoryListQuery.gql";
import CategoryRemoveMutation from "./graphql/CategoryRemoveMutation.gql";
import CategoryUpdateMutation from "./graphql/CategoryUpdateMutation.gql";

export default {
  components: {
    MediaImage,
    FormInputSearch,
    Pagination,
    TableRowActions,
    PublishingStatus
  },
  data() {
    return {
      results: {
        totalCount: 0,
        edges: []
      }
    };
  },
  apollo: {
    results: {
      query: CategoryListQuery,
      fetchPolicy: "network-only",
      variables() {
        return {
          pagination: {
            after: this.pagination.offset,
            limit: this.pagination.limit
          },
          search: this.filter.search
        };
      }
    }
  },
  computed: {
    categories() {
      return _map(this.results.edges, "node");
    },
    filter() {
      return this.$store.state.categories.filter;
    },
    pagination: {
      get() {
        return this.$store.state.categories.pagination;
      },
      set(value) {
        this.setPagination(value);
      }
    },
    search() {
      return this.filter.search;
    },
    isFiltered() {
      return _some(this.filter);
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$apollo.queries.results.refetch();
    });
  },
  methods: {
    ...mapActions('categories', [
      'setFilterSearch',
      'setPagination',
      'resetFilter'
    ]),
    async setCategoryPublished(category, published = true) {
      try {
        await this.$apollo.mutate({
          mutation: CategoryUpdateMutation,
          variables: {
            id: category.id,
            data: {published},
          }
        });
      } catch (err) {
        this.$store.dispatch("addNotificationError", err.message);
      }
    },
    async deleteCategory(category) {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: CategoryRemoveMutation,
          variables: {
            id: category.id
          }
        });
        if (data.result) {
          this.$store.dispatch(
            "addNotificationSuccess",
            `Le métier a été supprimé`
          );
          this.$apollo.queries.results.refetch();
        } else {
          this.$store.dispatch(
            "addNotificationError",
            `Le métier n'a pas pu être supprimé`
          );
        }
      } catch (err) {
        this.$store.dispatch("addNotificationError", err.message);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/categories/CategoriesList.vue